"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = require("react-dropzone");
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _uuid = require("uuid");
var _Dropzone = require("./Dropzone.types");
var _DropzoneFile = _interopRequireDefault(require("./DropzoneFile"));
var _DropzoneFileIcon = _interopRequireDefault(require("./DropzoneFileIcon"));
var _FeedbackContext = require("../feedback/FeedbackContext");
var _Icons = require("./Icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function Dropzone(_ref) {
  var maxFiles = _ref.maxFiles,
    extensions = _ref.extensions,
    path = _ref.path,
    s3Client = _ref.s3Client,
    disabled = _ref.disabled,
    onCompleted = _ref.onCompleted;
  var theme = (0, _material.useTheme)();
  var feedbackContext = (0, _react.useContext)(_FeedbackContext.FeedbackContext);
  var _useState = (0, _react.useState)(function () {
      return (0, _Dropzone.buildAccept)(extensions);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    accept = _useState2[0];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    rejectedFiles = _useState4[0],
    setRejectedFiles = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    acceptedFiles = _useState6[0],
    setAcceptedFiles = _useState6[1];
  var receivedFiles = (0, _react.useRef)([]);
  var onDrop = (0, _react.useCallback)(function (acceptedFiles, fileRejections, event) {
    var accepted = acceptedFiles.map(function (file) {
      var id = (0, _uuid.v4)();
      return {
        id: id,
        file: file,
        uploaded: false
      };
    });
    var rejected = fileRejections.map(function (el) {
      var id = (0, _uuid.v4)();
      return {
        id: id,
        name: el.file.name,
        reasons: el.errors.map(function (error) {
          return (0, _core.translate)("dropzone.codes.".concat(error.code));
        })
      };
    });
    if (maxFiles < accepted.length + rejected.length) {
      feedbackContext.showWarning((0, _core.translate)("dropzone.".concat(maxFiles === 1 ? 'single' : 'exceeded')));
      return;
    }
    setRejectedFiles(rejected);
    setAcceptedFiles(accepted);
    receivedFiles.current.splice(0, receivedFiles.current.length);
    accepted.map(function (el) {
      return {
        id: el.id,
        name: el.file.name,
        file: el.file,
        path: ''
      };
    }).forEach(function (el) {
      return receivedFiles.current.push(el);
    });
  }, [receivedFiles, maxFiles, feedbackContext]);
  var notifyChanges = (0, _react.useCallback)(function () {
    var uploaded = receivedFiles.current.filter(function (el) {
      return !!el.path;
    });
    var failed = receivedFiles.current.filter(function (el) {
      return !!el.error;
    });
    if (receivedFiles.current.length === uploaded.length + failed.length) {
      onCompleted(uploaded, failed);
    }
  }, [onCompleted]);
  var onUploaded = (0, _react.useCallback)(function (id, path, error) {
    var newAcceptedFiles = acceptedFiles.map(function (el) {
      if (el.id === id) {
        return Object.assign(Object.assign({}, el), {
          uploaded: true
        });
      }
      return el;
    });
    var found = receivedFiles.current.find(function (el) {
      return el.id === id;
    });
    if (found) {
      if (path) {
        found.path = path;
      }
      if (error) {
        found.error = error;
      }
    }
    notifyChanges();
    setAcceptedFiles(newAcceptedFiles);
  }, [acceptedFiles, receivedFiles, notifyChanges]);
  var onDeleted = (0, _react.useCallback)(function (index) {
    var found = acceptedFiles.find(function (el, i) {
      return i === index;
    });
    var newAcceptedFiles = acceptedFiles.filter(function (el, i) {
      return i !== index;
    });
    if (found) {
      var newReceivedFiles = receivedFiles.current.filter(function (el) {
        return el.id !== found.id;
      });
      receivedFiles.current = newReceivedFiles;
    }
    notifyChanges();
    setAcceptedFiles(newAcceptedFiles);
  }, [acceptedFiles, receivedFiles, notifyChanges]);
  var _useDropzone = (0, _reactDropzone.useDropzone)({
      maxFiles: maxFiles,
      accept: accept,
      multiple: maxFiles > 1,
      disabled: disabled,
      onDrop: onDrop
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragAccept = _useDropzone.isDragAccept,
    isDragReject = _useDropzone.isDragReject;
  var borderColor = (0, _react.useMemo)(function () {
    if (isDragAccept) {
      return theme.palette.success.main;
    }
    if (isDragReject) {
      return theme.palette.error.main;
    }
    if (isDragActive) {
      return theme.palette.info.main;
    }
    return theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[500];
  }, [isDragAccept, isDragActive, isDragReject, theme]);
  var backgroundColor = (0, _react.useMemo)(function () {
    return theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.grey[100];
  }, [theme]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Paper, Object.assign({
    variant: "outlined"
  }, getRootProps(), {
    sx: function sx(theme) {
      return {
        borderColor: borderColor,
        borderStyle: 'dashed',
        backgroundColor: backgroundColor,
        borderWidth: 2,
        padding: 2
      };
    }
  }), /*#__PURE__*/_react["default"].createElement("input", Object.assign({}, getInputProps())), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 2,
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    size: "small",
    variant: "outlined",
    color: "primary",
    disabled: disabled
  }, (0, _core.translate)('buttons.select'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    color: "textSecondary"
  }, (0, _core.translate)("dropzone.".concat(maxFiles === 1 ? 'drop_file' : 'drop_files')))))), acceptedFiles.length > 0 && (/*#__PURE__*/_react["default"].createElement(_material.List, {
    dense: true,
    disablePadding: true,
    subheader: /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      container: true,
      alignContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _core.translate)('dropzone.accepted_files'))),
    sx: {
      marginTop: 2
    }
  }, acceptedFiles.map(function (acceptedFile, index) {
    return /*#__PURE__*/_react["default"].createElement(_DropzoneFile["default"], {
      index: index,
      key: acceptedFile.id,
      acceptedFile: acceptedFile,
      path: path,
      s3Client: s3Client,
      onUploaded: onUploaded,
      onDeleted: onDeleted
    });
  }))), rejectedFiles.length > 0 && (/*#__PURE__*/_react["default"].createElement(_material.List, {
    dense: true,
    disablePadding: true,
    subheader: /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      container: true,
      alignContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: true
    }, (0, _core.translate)('dropzone.rejected_files')), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: "auto"
    }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
      size: "small",
      onClick: function onClick() {
        return setRejectedFiles([]);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icons.CloseIcon, null)))),
    sx: {
      marginTop: 2
    }
  }, rejectedFiles.map(function (rejectedFile) {
    return /*#__PURE__*/_react["default"].createElement(_material.ListItem, {
      key: rejectedFile.id,
      dense: true
    }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_DropzoneFileIcon["default"], {
      filename: rejectedFile.name,
      status: "rejected"
    })), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
      primary: rejectedFile.name,
      secondary: rejectedFile.reasons.join(', ')
    }));
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Dropzone);